import { faArrowUpToLine } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ImportButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  return (
    <Button
      size="large"
      className="text-sm"
      icon={<FontAwesomeIcon icon={faArrowUpToLine} />}
      onClick={onClick}
    >
      {t('button.import')}
    </Button>
  );
};

export default ImportButton;
